<template>
  <div class="l-btn" :class="{'grey': !canUse, 'blue': blue}" :style="style" @click="confirm">{{text}}</div>
</template>

<script>

  import rem from '@edu-fe/rem'

  export default {
    name: 'LongBtn',
    props: {
      // 按钮文字信息
      text: {
        type: String,
        default: '确认',
      },
      // 是否可用
      canUse: {
        type: Boolean,
        default: false,
      },
      // 宽度
      width: {
        type: Number,
        default: 592
      },
      // 蓝色
      blue: Boolean
    },

    computed: {
      style () {
        return {
          width: rem.design2rem(this.width) + 'rem'
        }
      }
    },

    methods: {
      confirm() {
        if (!this.canUse) return
        this.$emit('confirm')
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .l-btn {
    // width: use(592);
    height: use(90);
    font-weight: bold;
    font-size: use(36);
    line-height: use(90);
    color: #FFFFFF;
    background-image: linear-gradient(135deg, #FF9C51 0%, #FF6914 100%);
    box-shadow: 0 use(10) use(20) 0 rgba(255, 115, 40, 0.50);
    border-radius: use(10);
    text-align: center;
    margin: 0 auto;
    letter-spacing: use(4);

    &.grey {
      background-image: linear-gradient(135deg, #CFCFCF 0%, #C2C2C2 100%);
      box-shadow: 0 use(10) use(20) 0 rgba(201, 201, 201, 0.50);
    }

    &.blue {
      background-image: linear-gradient(135deg, #00B1FF 0%, #00A3F4 100%);
      box-shadow: none;
      font-size: use(30);
      font-weight: normal;
    }

  }
</style>